import { createGraphFromSteps, parseYAML } from "app/lib/pipeline";
import useTemplate from "./useTemplate";
import { useBuild } from "app/components/build/Show/lib/BuildContext";
import { useMemo } from "react";

/**
 * Create a ReactFlow graph from either pipeline YAML or a build.
 */
export const useGraph = ({
  templateID,
  expandedGroupSteps,
  removeIgnoredSteps = true,
}: {
  templateID?: string;
  removeIgnoredSteps?: boolean;
  expandedGroupSteps?: Set<string>;
}) => {
  const { build } = useBuild({ strict: false });
  const { yaml } = useTemplate(templateID);

  return useMemo(() => {
    if (templateID) {
      if (yaml) {
        return createGraphFromSteps(parseYAML(yaml), {
          removeIgnoredSteps,
          flattenImplicitGroupChildrenDependencies: true,
        });
      }
      return { nodes: [], edges: [] };
    } else if (build) {
      return createGraphFromSteps(build.steps, {
        removeIgnoredSteps,
        expandedGroupSteps,
        flattenImplicitGroupChildrenDependencies: true,
      });
    }

    return { nodes: [], edges: [] };
  }, [yaml, build, removeIgnoredSteps, expandedGroupSteps]);
};
